import { createRef, RefObject, useEffect, useState } from "react";
import "../../App.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSmog } from "@fortawesome/free-solid-svg-icons";
import { faCloudShowersWater } from "@fortawesome/free-solid-svg-icons";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import { Feature } from "ol";
import { fromLonLat } from "ol/proj";
import { Point } from "ol/geom";
import { map } from "../../mainLayer/MainLayer";
import { LocationMarkerPopup } from "../../mainLayer/MainWindow";
import Overlay from "ol/Overlay.js";
import ReactDOM from "react-dom";
import Style from "ol/style/Style";
import Icon from "ol/style/Icon";
import { Coordinate } from "ol/coordinate";
import { useTheme } from "../../theme/ThemeContext";

import {
  layerButtonValue,
  openWindowsMapRiver,
  riverMap,
} from "../../../src/riverSensors/RiverSensors";
import { useMenu } from "../../roundMenuContext/roundMenuContext";
import { useAllWeatherContext } from "../../provider/AllWeatherProvider";
import rain from "../../assets/rainfall.png";
import moderateSensor from "../../assets/moderate.png";
import sensitveunhelathySensor from "../../assets/sensitveunhelathy.png";
import unhelathySensor from "../../assets/unhealthy.png";
import veryunhealthySensor from "../../assets/veryunhealthy.png";
import harzardusSensor from "../../assets/hazardus.png";
import {
  EWSSidebarMap,
  openEwsWindowsMap,
} from "../earlyWarning/ShowEarlyWarning";
import {
  HzSidebarMap,
  openWindowsHzMap,
} from "../hazardIncidentsLayers/IncidentsMenuDropDown";
import { useRainfallContext } from "../../provider/RainfallProvider";
import AirQualityPopup from "../airQuality/airQualityPopup";
import {
  airQualityMap,
  openWindowsAirQualityMap,
} from "../airQuality/airQuality";
import AddRainfallLayer from "./AddRainfallLayer";
import RainfallPopup from "./RainfallPopup";

export interface RainfallSensor {
  id: string;
  latitude: number;
  longitude: number;
  name: string;
  threshold_critical: number;
  threshold_cautious: number;
  threshold_warning: number;
}

export interface RainfallDetails {
  sensorId: string | null;
  name: string | null;
  cautionLevel: number | null;
  warningLevel: number | null;
  criticalLevel: number | null;
  coordinates: Coordinate | null;
}
export const clickedRainfallLayerRef: RefObject<
  VectorLayer<VectorSource<Feature<Point>>>
> = createRef();
export const rainfallMap: Map<string, RainfallDetails> = new Map();
export const openWindowsRainfallMap = new Map<string, string>();
export const openMarkers = new Map<string, boolean>();
const openMarkersSet = new Set<string>();

interface RainfallSensorsProps {
  senddValueFromRainfall: (value: string) => void;
  sensorType: (value: string) => void;
  openModular: (value: string) => void;
  renderRainfallSensor: (value: boolean) => void;
  sidebarOpen: (value: boolean) => void;
  minMenuRain: boolean;
  minMenuRainLeft: (value: boolean) => void;
}

const Rainfall: React.FC<RainfallSensorsProps> = ({
  senddValueFromRainfall,
  sensorType,
  openModular,
  renderRainfallSensor,
  sidebarOpen,
  minMenuRain,
  minMenuRainLeft,
}) => {
  const [rainfallSensors, setRainfallSensors] = useState<RainfallSensor[]>([]);
  const [isClicked, setIsClicked] = useState<boolean>(true);
  const [isClickedMini, setIsClickedMini] = useState<boolean>(true);
  const [hoveredRainfall, setHoveredRainfall] = useState(false);
  const { theme } = useTheme();
  const { menu } = useMenu();
  const [_, setRender] = useState(false);
  const { setMarker } = useAllWeatherContext();
  const {
    RainfallOpenSidebarMap,
    removeFromRainfallOpenSidebarMap,
    clearRainfallOpenSidebarMap,
    setRainfallOpenSidebarMap,
    setIsLeftkeyClickRain,
    setIsLeftRain,
    isMinEyeClickRain,
    setIsMinEyeClickRain,
  } = useRainfallContext();
  const toggleSensorVisibility = () => {
    setRender((prevRender) => {
      const newRender = !prevRender;
      renderRainfallSensor(newRender);
      return newRender;
    });
  };

  const handleButtonClick = () => {
    setIsClicked((prevState) => !prevState);
    fetchData();
    LocationMarkerPopup("rainfall");
    if (!isClicked) {
      const entries = Array.from(RainfallOpenSidebarMap.values());
      entries.forEach((details, index) => {
        const { coordinates, sensorId } = details;
        if (coordinates) {
          removeOverlay(sensorId!);
          openWindowsRainfallMap.set(sensorId!, "close");
        }
      });
      clearRainfallOpenSidebarMap();
    }
  };

  useEffect(() => {
    if (menu === "Rainfall") {
      handleButtonClick();
    }
  }, [menu]);

  useEffect(() => {
    if (isMinEyeClickRain) {
      handleButtonClick();
    }
  }, [minMenuRain]);

  useEffect(() => {
    if (!isClicked) {
      senddValueFromRainfall("Rainfall");

      minMenuRainLeft(false);
    } else {
      senddValueFromRainfall("");
      minMenuRainLeft(true);
    }
  }, [isClicked]);

  const RAIN_URL = process.env.REACT_APP_RAIN_URL;
  const RAIN_DATA_URL = process.env.REACT_APP_RAIN_DATA_URL;


  const fetchData = async () => {
    try {
      const response = await fetch(`${RAIN_URL}`);
      const responseData = await response.json();

      if (Array.isArray(responseData)) {
        const data: RainfallSensor[] = responseData;

        setRainfallSensors(data);
        createOpenPopupmap(data);
      } else {
        console.error("Invalid response data format:", responseData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const createOpenPopupmap = (data: RainfallSensor[]) => {
    data.forEach((air) => {
      openWindowsRainfallMap.set(air.id, "close");
    });
  };

  useEffect(() => {
    if (rainfallSensors.length > 0) {
      createMapWithMarkers();
    }
  }, [rainfallSensors]);

  const fetchSensorCurrentValue = async (
    id: string
  ): Promise<{ level: number; time?: string } | null> => {
    try {
      const response = await fetch(
        `${RAIN_DATA_URL}${id}`
      );
      const responseData = await response.json();

      if (responseData && typeof responseData.level === "number") {
        // Handle cases where 'time' may be missing
        if (typeof responseData.time === "string") {
          return { level: responseData.level, time: responseData.time };
        } else {
          console.warn(
            "Response is missing 'time', returning only 'level':",
            responseData
          );
          return { level: responseData.level };
        }
      } else {
        console.error(
          "Invalid response data format or missing 'level':",
          responseData
        );
        return null;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      return null;
    }
  };

  const createMapWithMarkers = async () => {
    const vectorSource = new VectorSource();
    const vectorLayer = new VectorLayer({
      source: vectorSource,
    });

    const sensorRain = new Style({
      image: new Icon({
        anchor: [0.5, 1],
        src: rain,
        scale: 0.3,
      }),
    });

    // const sensorModerate = new Style({
    //   image: new Icon({
    //     anchor: [0.5, 1],
    //     src: moderateSensor,
    //     scale: 0.3,
    //   }),
    // });

    // const sensorSensitive = new Style({
    //   image: new Icon({
    //     anchor: [0.5, 1],
    //     src: sensitveunhelathySensor,
    //     scale: 0.3,
    //   }),
    // });

    // const sensorUnhelathy = new Style({
    //   image: new Icon({
    //     anchor: [0.5, 1],
    //     src: unhelathySensor,
    //     scale: 0.3,
    //   }),
    // });

    // const sensorVeryUnhelathy = new Style({
    //   image: new Icon({
    //     anchor: [0.5, 1],
    //     src: veryunhealthySensor,
    //     scale: 0.3,
    //   }),
    // });

    // const sensorHazardus = new Style({
    //   image: new Icon({
    //     anchor: [0.5, 1],
    //     src: harzardusSensor,
    //     scale: 0.3,
    //   }),
    // });

    const sensorLevels2 = await Promise.all(
      rainfallSensors.map(async (marker) => {
        const result = await fetchSensorCurrentValue(marker.id);

        if (result) {
          return {
            marker,
            level: result.level,
            time: result.time || "N/A", // Fallback if 'time' is missing
          };
        } else {
          return { marker, level: null, time: null };
        }
      })
    );

    const newFeatures = sensorLevels2.map(({ marker, level, time }) => {
      const point = new Point(fromLonLat([marker.longitude, marker.latitude]));

      const feature = new Feature({
        geometry: point,
        id: marker.id,
        name: marker.name,
        time: time,
      });
      let style;
      if (level !== null) {
        style = sensorRain;
      }
      feature.setStyle(style);
      return feature;
    });

    vectorSource.addFeatures(newFeatures);

    map.on("click", (evt) => {
      const feature = map.forEachFeatureAtPixel(evt.pixel, (feature) => {
        return feature;
      });

      if (feature) {
        setMarker("clickMarker");
      }
      const value = feature
        ? openWindowsRainfallMap.get(feature.get("id"))
        : undefined;

      if (
        feature &&
        feature.get("time") &&
        // feature.get("cautionLevel") &&
        value === "close"
      ) {
        const geometry = feature.getGeometry() as Point;
        const coordinates = geometry.getCoordinates();
        const sensorId = feature.get("id");
        const name = feature.get("name");
        const cautionLevel = feature.get("cautionLevel");
        const warningLevel = feature.get("warningLevel");
        const criticalLevel = feature.get("criticalLevel");
        if (name) {
          // LocationMarkerPopup("airquality");
          openWindowsRainfallMap.set(sensorId, "open");
          showPopup(
            sensorId,
            coordinates,
            name,
            cautionLevel,
            warningLevel,
            criticalLevel
          );
          if (layerButtonValue === "hawk eye") {
            const entries = Array.from(RainfallOpenSidebarMap.values());
            const lastEntryIndex = entries.length - 1;
            entries.forEach((details, index) => {
              const { coordinates, sensorId } = details;
              if (coordinates) {
                removeOverlay(sensorId!);
                if (index === lastEntryIndex) {
                  addOverlayClickItemLast(sensorId!, coordinates);
                } else {
                  addOverlayClickItem(sensorId!, coordinates);
                }
              }
            });
          }
        }
      }
      setTimeout(() => {
        setMarker("notClickMarker");
      }, 500);
    });

    AddRainfallLayer(vectorLayer, isClicked, "rainfall");
  };

  useEffect(() => {
    const entries = Array.from(RainfallOpenSidebarMap.values());
    const lastEntryIndex = entries.length - 1;
    entries.forEach((details, index) => {
      const { coordinates, sensorId } = details;
      if (coordinates) {
        removeOverlay(sensorId!);
        if (index === lastEntryIndex) {
          // Handle last entry
          addOverlayClickItemLast(sensorId!, coordinates);
        } else {
          // Handle all other entries
          addOverlayClickItem(sensorId!, coordinates);
        }
      }
    });
  }, [RainfallOpenSidebarMap.size]);

  const removeOverlay = (key: string) => {
    const overlays = map.getOverlays().getArray();
    const overlaysToRemove = overlays.filter(
      (overlay) => overlay.getId() === key
    );
    overlaysToRemove.forEach((overlay) => {
      map.removeOverlay(overlay);
    });
  };

  const addOverlayClickItem = (id: string, coordinates: Coordinate) => {
    const markerElement = document.createElement("div");
    markerElement.className = "location-dot animate";

    const ringElement = document.createElement("div");
    ringElement.className = "location-dot-ring";

    markerElement.appendChild(ringElement);
    const overlay = new Overlay({
      id: id,
      position: coordinates,
      positioning: "center-center",
      element: markerElement,
      stopEvent: false,
    });
    map.addOverlay(overlay);
  };

  const addOverlayClickItemLast = (id: string, coordinates: Coordinate) => {
    const markerElement = document.createElement("div");
    markerElement.className = "locationlast-dot animate";

    const ringElement = document.createElement("div");
    ringElement.className = "locationlast-dot-ring";

    markerElement.appendChild(ringElement);
    const overlay = new Overlay({
      id: id,
      position: coordinates,
      positioning: "center-center",
      element: markerElement,
      stopEvent: false,
    });
    map.addOverlay(overlay);
  };

  const handleClose = (incidentId: string) => {
    openWindowsRainfallMap.set(incidentId, "close");
    openMarkers.set(incidentId, false);
    if (rainfallMap.has(incidentId)) {
      rainfallMap.delete(incidentId);
    }
    if (RainfallOpenSidebarMap.has(incidentId)) {
      RainfallOpenSidebarMap.delete(incidentId);
    }
    const entries = Array.from(RainfallOpenSidebarMap.values());
    const lastEntryIndex = entries.length - 1;
    entries.forEach((details, index) => {
      const { coordinates, sensorId } = details;
      if (coordinates) {
        removeOverlay(sensorId!);
        if (index === lastEntryIndex) {
          // Handle last entry
          addOverlayClickItemLast(sensorId!, coordinates);
        } else {
          // Handle all other entries
          addOverlayClickItem(sensorId!, coordinates);
        }
      }
    });
  };

  useEffect(() => {}, [rainfallMap.entries()]);

  useEffect(() => {}, [openMarkers]);

  const showPopup = (
    sensorId: string | null,
    coordinates: Coordinate | null,
    name: string | null,
    cautionLevel: number | null,
    warningLevel: number | null,
    criticalLevel: number | null
  ) => {
    toggleSensorVisibility();
    sensorType("rainfallSensor");
    if (layerButtonValue === "modular") {
      const entries = Array.from(riverMap.values());
      entries.forEach((details, index) => {
        const { coordinates, sensorId } = details;
        if (coordinates) {
          removeOverlay(sensorId!);
          openWindowsMapRiver.set(sensorId!, "close");
        }
      });
      const entriesEws = Array.from(EWSSidebarMap.values());
      entriesEws.forEach((details, index) => {
        const { coordinates, active_pcode } = details;
        if (coordinates) {
          removeOverlay(active_pcode!);
          openEwsWindowsMap.set(active_pcode!, "close");
        }
      });
      const entriesHz = Array.from(HzSidebarMap.values());
      entriesHz.forEach((details, index) => {
        const { coordinates, sensorId } = details;
        if (coordinates) {
          removeOverlay(sensorId!);
          openWindowsHzMap.set(sensorId!, "close");
        }
      });

      const entriesAir = Array.from(airQualityMap.values());
      entriesAir.forEach((details, index) => {
        const { coordinates, sensorId } = details;
        if (coordinates) {
          removeOverlay(sensorId!);
          openWindowsAirQualityMap.set(sensorId!, "close");
        }
      });
    }
    //  riverMap.clear();
    //  EWSSidebarMap.clear();
    //  clearEWSOpenSidebarMap();
    if (
      sensorId &&
      coordinates &&
      name
      // cautionLevel &&
      // warningLevel &&
      // criticalLevel
    ) {
      const popupElement = document.createElement("rainfall");
      if (layerButtonValue === "hawk eye") {
        ReactDOM.render(
          <RainfallPopup
            sensorId={sensorId}
            name={name}
            // cautionLevel={cautionLevel}
            // warningLevel={warningLevel}
            // criticalLevel={criticalLevel}
            onClose={handleClose}
          />,
          popupElement
        );
        const overlay = new Overlay({
          element: popupElement,
          autoPan: {
            animation: {
              duration: 250,
            },
          },
        });

        overlay.setPosition(coordinates);
        map.addOverlay(overlay);
        const newRainfall: RainfallDetails = {
          sensorId: sensorId,
          name: name,
          cautionLevel: cautionLevel,
          warningLevel: warningLevel,
          criticalLevel: criticalLevel,
          coordinates: coordinates,
        };
        rainfallMap.set(newRainfall.sensorId!, newRainfall);
        setRainfallOpenSidebarMap(newRainfall.sensorId!, newRainfall);
      } else if (layerButtonValue === "modular") {
        const newRainfall: RainfallDetails = {
          sensorId: sensorId,
          name: name,
          cautionLevel: cautionLevel,
          warningLevel: warningLevel,
          criticalLevel: criticalLevel,
          coordinates: coordinates,
        };
        openModular("modularOpened");
        rainfallMap.set(newRainfall.sensorId!, newRainfall);
        setRainfallOpenSidebarMap(newRainfall.sensorId!, newRainfall);

        sidebarOpen(true);
      }
    }
  };

  useEffect(() => {
    if (isClickedMini) {
      setIsLeftRain(false);
    } else {
      setIsLeftRain(true);
    }
  }, [isClickedMini]);

  return (
    <>
      <div
        className="leftsidemenulist-btn-cover"
        onClick={() => {
          setIsMinEyeClickRain(false);
          handleButtonClick();
          setIsLeftkeyClickRain(true);
          setIsClickedMini((prevState) => !prevState);
        }}
        onTouchStart={() => {
          handleButtonClick();
          setIsLeftkeyClickRain(true);
          setIsClickedMini((prevState) => !prevState);
        }}
      >
        <div
          onMouseEnter={() => setHoveredRainfall(true)}
          onMouseLeave={() => setHoveredRainfall(false)}
          className="leftsidemenulist-btns"
        >
          <FontAwesomeIcon
            size="1x"
            icon={faCloudShowersWater}
            className="leftside-icon"
          />
        </div>
        {theme === "light" && (
          <div
            className={
              isClicked
                ? hoveredRainfall
                  ? "leftsidemenulist-btn-tooltip-hover-light"
                  : "leftsidemenulist-btn-tooltip-light"
                : "leftsidemenulist-btn-tooltip-clicked-light"
            }
            onMouseEnter={() => setHoveredRainfall(true)}
            onMouseLeave={() => setHoveredRainfall(false)}
          >
            Rainfall
          </div>
        )}
        {theme !== "light" && (
          <div
            className={
              isClicked
                ? hoveredRainfall
                  ? "leftsidemenulist-btn-tooltip-hover"
                  : "leftsidemenulist-btn-tooltip"
                : "leftsidemenulist-btn-tooltip-clicked"
            }
            onMouseEnter={() => setHoveredRainfall(true)}
            onMouseLeave={() => setHoveredRainfall(false)}
          >
            Rainfall
          </div>
        )}
      </div>
    </>
  );
};

export default Rainfall;
